import { useLanguage } from "../../../../context/LanguageContext";
import { Button } from "../../../../components/ui/button";
import { ArrowUpDown, Eye, File, MoreHorizontal, User } from "lucide-react";
import { DataTable } from "../../../../components/DataTable";
import { SubLessonData } from "../../../../lib/languages";
import DrawerEditHomeWork from "../../Lesson/Tabs/HomeWork/DrawerEditHomeWork";
import DialogDeleteHomeWork from "../../Lesson/Tabs/HomeWork/DialogDeleteHomeWork";
import DialogFilesAssignments from "./DialogFilesAssignments";
import { parseField } from "../../../../lib/utils";
import { DialogShowAnswer } from "../../Lesson/Tabs/HomeWork/Answer/DialogShowAnswer";
import DialogAnswerHomeWork from "../../Lesson/Tabs/HomeWork/Answer/DialogAnswerHomeWork";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../../../../components/ui/dropdown-menu";

const TableAssignments = ({ data = [], fetchAssignments, isTeacher }) => {
  const { language } = useLanguage();
  const t = SubLessonData[language] || SubLessonData["en"];

  const columns = [
    {
      accessorKey: "title.en",
      header: ({ column }) => (
        <Button
          variant="ghost"
          className="p-0 hover:bg-transparent"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          {t.columnTitleEn}
          <ArrowUpDown className="h-4 w-4" />
        </Button>
      ),
      cell: ({ row }) =>
        row.original.title.en ? parseField(row.original.title, "en") : "---",
    },
    {
      accessorKey: "title.ar",
      header: ({ column }) => (
        <Button
          variant="ghost"
          className="p-0 hover:bg-transparent"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          {t.columnTitleAr}
          <ArrowUpDown className="h-4 w-4" />
        </Button>
      ),
      cell: ({ row }) =>
        row.original.title.ar ? parseField(row.original.title, "ar") : "---",
    },
    {
      accessorKey: "score",
      header: t.columnScore,
      cell: ({ row }) => <span>{row.original.score}</span>,
    },
    {
      accessorKey: "max_items",
      header: t.maxFiles,
      cell: ({ row }) => <span>{row.original.max_items}</span>,
    },
    {
      accessorKey: "due_date",
      header: t.expireDate,
      cell: ({ row }) => <span>{row.original.due_date || "---"}</span>,
    },
    {
      accessorKey: "Files Count",
      header: t.columnFilesCount,
      cell: ({ row }) => <span>{row.original.files?.length || 0}</span>,
    },
    {
      accessorKey: "actions",
      header: t.columnActions,
      cell: ({ row }) => {
        const item = row.original;
        return (
          <div className="flex items-center gap-2">
            {isTeacher ? (
              <>
                <DialogFilesAssignments item={item} />
                <DrawerEditHomeWork
                  item={item}
                  fetchAssignments={fetchAssignments}
                  isTeacher={true}
                />
                <DialogDeleteHomeWork
                  item={item}
                  fetchAssignments={fetchAssignments}
                  isTeacher={true}
                />
              </>
            ) : (
              <>
                <DropdownMenu>
                  <DropdownMenuTrigger asChild>
                    <Button variant="ghost" className="h-8 w-8 p-0">
                      <span className="sr-only">Open menu</span>
                      <MoreHorizontal className="h-4 w-4" />
                    </Button>
                  </DropdownMenuTrigger>
                  <DropdownMenuContent align="end">
                    <DropdownMenuLabel>Actions</DropdownMenuLabel>
                    <DropdownMenuItem
                      className="p-0 py-1"
                      onSelect={(e) => e.preventDefault()}
                    >
                      <DialogShowAnswer
                        answers={item.answers}
                        onOpen={() => fetchAssignments()}
                        isTable={true}
                      />
                    </DropdownMenuItem>
                    <DropdownMenuSeparator />
                    <DropdownMenuItem
                      className="p-0 py-1"
                      onSelect={(e) => e.preventDefault()}
                    >
                      <DialogFilesAssignments item={item}>
                        <Button
                          variant="ghost"
                          size="sm"
                          className="text-primary"
                        >
                          <File className="h-4 w-4 me-1 text-blue-600" />
                          {t.showHomework}
                        </Button>
                      </DialogFilesAssignments>
                    </DropdownMenuItem>

                    <DropdownMenuItem
                      className="p-0 py-1"
                      onSelect={(e) => e.preventDefault()}
                    >
                      <DialogAnswerHomeWork
                        item={item}
                        fetchAnswers={fetchAssignments}
                      />
                    </DropdownMenuItem>
                  </DropdownMenuContent>
                </DropdownMenu>
              </>
            )}
          </div>
        );
      },
    },
  ];

  return (
    <DataTable
      columns={columns}
      data={data}
      title={t.tableAssignmentsTitle}
      filterNames={["title_ar", "title_en", "score"]}
    />
  );
};

export default TableAssignments;
